import { PlacementTestPage } from './PlacementTestPage'

/**
 * Полноэкранный мастер онбординга.
 *
 * Это тот же тест уровня, что и на `/placement`, но без кабинета вокруг: для
 * ученика, зашедшего впервые, боковое меню — это список разделов, в которых он
 * ещё ничего не понимает, а первый экран должен звать делать одно дело.
 *
 * Отдельной копии экрана нет намеренно: логика прохождения одна, и две её
 * версии разъехались бы на первой же правке.
 */
export function OnboardingPage() {
  return <PlacementTestPage variant="onboarding" />
}
